module.exports = __webpack_public_path__ + "50b957e0a6fe5d2975d65d8a86553dd7.png";